import React from 'react';
import styled from 'styled-components';
import fonts from 'const/style/fonts';
import imgNotFound from 'assets/img/img_not_found@2x.png';

const Frame = styled.div`
  width:100%;
  height:100%;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  background-color:#F0F3FA;
  .title {
    margin-top:50px;
    font: Bold 24px NanumSquare;
  }
  .desc {
    margin-top:30px;
    white-space:pre-line;
    ${fonts.H2_Regular};
  }
  .img-not-found {
    width:518px;
  }
`;

const NotFound = () => {
  return (
    <Frame>
      <img className='img-not-found' src={imgNotFound} alt='NOT FOUND' />
      <div className='title'>
      요청하신 페이지를 처리할 수 없습니다.
      </div>
      <div className='desc'>
        {
          `서비스 이용에 불편을 드려 죄송합니다.\n서비스 이용 중 동일한 현상이 반복될 경우, 관리자 또는 고객센터에 문의해 주시기 바랍니다.`
        }
      </div>
    </Frame>
  )
}

export default NotFound;